module.exports = __webpack_public_path__ + "images/3884bb7d50eb8f91ca6a20d5aadcc6e3.png";